import { useEffect, useRef, useState } from "react";
import { Smile } from "lucide-react";

const EMOJI_GROUPS = {
  "Häufig": ["😀","😂","🤣","😍","🥰","😎","🤔","👍","👎","❤️","🔥","💯","🙏","👌","✅","❌","🚀","💪","👏","🎉"],
  "Smileys": ["😀","😃","😄","😁","😆","🥹","😅","😂","🤣","🥲","😊","😇","🙂","🙃","😉","😌","😍","🥰","😘","😗","😙","😚","😋","😛","😝","😜","🤪","🤨","🧐","🤓","😎","🥸","🤩","🥳","😏","😒","😞","😔","😟","😕","🙁","☹️","😣","😖","😫","😩","🥺","😢","😭","😤","😠","😡","🤬"],
  "Hände": ["👍","👎","👌","🤌","🤏","✌️","🤞","🤟","🤘","🤙","👈","👉","👆","🖕","👇","☝️","👏","🙌","👐","🤲","🙏","✍️","💪","🦵","🦶","👀","👂","👃","🧠","🫀","🫁","🦷","🦴","👅","👄","💋"],
  "Fahren": ["🚗","🚕","🚙","🚌","🚎","🏎️","🚓","🚑","🚒","🚐","🛻","🚚","🚛","🚜","🛵","🏍️","🛺","🚲","🛴","🛹","🛼","🚏","🛣️","🛤️","🛢️","⛽","🚧","🚦","🚥","🗺️","🗿","🚀","🛸","✈️","⚓","🛟","🆘"],
  "Symbole": ["❤️","🧡","💛","💚","💙","💜","🖤","🤍","🤎","💔","❣️","💕","💞","💓","💗","💖","💘","💝","💟","❗","❓","⭕","🔴","🟠","🟡","🟢","🔵","🟣","⚫","⚪","🟤","🟥","🟧","🟨","🟩","🟦","🟪","⬛","⬜","🟫","🔺","🔻","🔸","🔹","✨","⭐","🌟","💫","☀️","🌙","☁️","🌧️","⛈️","❄️","💯","🔥","💥"],
};

export default function EmojiPicker({ onPick, buttonClassName = "", iconClassName = "" }) {
  const [open, setOpen] = useState(false);
  const [group, setGroup] = useState("Häufig");
  const ref = useRef(null);

  useEffect(() => {
    if (!open) return;
    const handler = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    window.addEventListener("mousedown", handler);
    return () => window.removeEventListener("mousedown", handler);
  }, [open]);

  return (
    <div className="relative" ref={ref}>
      <button
        type="button"
        onClick={() => setOpen((s) => !s)}
        data-testid="emoji-picker-btn"
        className={buttonClassName || "p-3 rounded-2xl bg-[#FFFFFF] border border-slate-200 text-slate-700 hover:text-slate-900 hover:border-[#1D5BFF]/50 transition-all"}
        title="Emoji einfügen"
      >
        <Smile className={iconClassName || "w-5 h-5"} />
      </button>

      {open && (
        <div
          className="absolute bottom-full right-0 mb-2 w-80 max-w-[90vw] bg-[#FFFFFF] border border-slate-200 rounded-2xl shadow-2xl z-50 overflow-hidden"
          data-testid="emoji-picker-panel"
        >
          <div className="flex gap-1 px-3 py-2 border-b border-slate-200 overflow-x-auto">
            {Object.keys(EMOJI_GROUPS).map((g) => (
              <button
                key={g}
                onClick={() => setGroup(g)}
                data-testid={`emoji-group-${g}`}
                className={`shrink-0 px-2.5 py-1 rounded-full text-[11px] font-semibold transition-colors ${group === g ? "bg-[#1D5BFF] text-white" : "text-slate-600 hover:text-slate-900"}`}
              >
                {g}
              </button>
            ))}
          </div>
          <div className="p-2 max-h-64 overflow-y-auto grid grid-cols-8 gap-1">
            {EMOJI_GROUPS[group].map((e, i) => (
              <button
                key={`${group}-${i}`}
                type="button"
                onClick={() => { onPick(e); setOpen(false); }}
                className="text-2xl hover:bg-slate-100 rounded-lg transition-colors aspect-square flex items-center justify-center"
                data-testid={`emoji-${e}`}
              >
                {e}
              </button>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
